// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { store } from './store/store';
import VueMoment  from 'vue-moment';
import moment from 'moment-timezone'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

/* IE Support start*/
import 'core-js/es6/number';
import 'core-js/shim';
/* IE Support End*/

Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSweetalert2 from 'vue-sweetalert2';
import Validation from 'vee-validate';



Vue.use(Validation);

Vue.use(VueSweetalert2);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js